<div>
  <div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <mat-sidenav-container class="sidenav-all">
      <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
        [opened]="!mobileQuery.matches">
        <div class="emp-style">
          @if (logoPath) {
          <a href="https://ambato.gob.ec/" target="_blank">
            <img [src]="logoPath" alt="Logo" style="filter:drop-shadow(0 0 0.05rem white)">
          </a>
          }
        </div>
        
          <div class="container">
            <div class="text-layer">SmartOfi<br>Versi&oacute;n: 2.3.5<br> <a href="https://es.wikipedia.org/wiki/Sula_nebouxii"
            target="_blank">Piquero Camanay</a></div>
            <img src="assets/version-logo.png" alt="Overlay Image" class="image-layer">
          </div>

        <mat-nav-list>
          <mat-expansion-panel expanded="true">
            <a mat-list-item routerLink="" routerLinkActive="active" [routerLinkActiveOptions]={exact:true}
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>home</mat-icon>
              <div matListItemTitle>Inicio</div>
            </a>
            <a mat-list-item matTooltip="Crear memorandos, oficios, circulares, etc." routerLink="nuevo"
              routerLinkActive="active" (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>edit_document</mat-icon>
              <div matListItemTitle>Nuevo documento</div>
            </a>
          </mat-expansion-panel>

          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true" (opened)="panelOpenState = true">
            <mat-expansion-panel-header>
              <mat-panel-description class="submenu">
                Bandejas
              </mat-panel-description>
            </mat-expansion-panel-header>
            <a mat-list-item routerLink="/borrador" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>hourglass_empty</mat-icon>
              <div matListItemTitle>En elaboraci&oacute;n@if (utilService.signalTasks().enElaboracion>0) {
                <span matBadge="{{utilService.signalTasks().enElaboracion}}" matBadgeOverlap="false">&nbsp;</span>
                }
              </div>
            </a>
            <a mat-list-item routerLink="/recibido" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>move_to_inbox</mat-icon>
              <div matListItemTitle>Recibidos@if (utilService.signalTasks().recibido>0) {
                <span matBadge="{{utilService.signalTasks().recibido}}" matBadgeOverlap="false">&nbsp;</span>
                }
              </div>
            </a>
            <a mat-list-item routerLink="/enviado" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>send</mat-icon>
              <div matListItemTitle>Enviados</div>
            </a>
            <a mat-list-item routerLink="/recibida" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>input</mat-icon>
              <span matListItemTitle>Tareas recibidas@if (utilService.signalTasks().tareaRecibida>0) {
                <span matBadge="{{utilService.signalTasks().tareaRecibida}}" matBadgeOverlap="false">&nbsp;</span>
                }
              </span>
            </a>
            <a mat-list-item routerLink="/enviada" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>output</mat-icon>
              <div matListItemTitle>Tareas enviadas</div>
            </a>
          </mat-expansion-panel>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true" (opened)="panelOpenState = true">
            <mat-expansion-panel-header>
              <mat-panel-description class="submenu">
                Otras actividades
              </mat-panel-description>
            </mat-expansion-panel-header>
            <a mat-list-item routerLink="/busqueda" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon>manage_search</mat-icon>
              <div matListItemTitle>B&uacute;squeda avanzada</div>
            </a>
            <a mat-list-item routerLink="/reportes" routerLinkActive="active"
              (click)="mobileQuery.matches ?snav.close():''">
              <mat-icon matListItemIcon class="material-symbols-outlined">analytics</mat-icon>
              <div matListItemTitle>Reportes</div>
            </a>
            <a mat-list-item routerLink="/archivados" routerLinkActive="active"
            (click)="mobileQuery.matches ?snav.close():''">
            <mat-icon matListItemIcon class="material-symbols-outlined">save</mat-icon>
            <div matListItemTitle>Archivados</div>
          </a>
          </mat-expansion-panel>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content>
        <mat-toolbar class="example-toolbar">
          <button mat-icon-button (click)="snav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
          @if (mobileQuery.matches) {
          <a mat-icon-button routerLink="/">
            <mat-icon>home</mat-icon>
          </a>
          }
          <h1 class="example-app-name">
            <div>{{titleService.titleSignal()}}</div>
            @if (!mobileQuery.matches) {
            <span class="app-subtitle">{{title}}&nbsp;</span>
            }
          </h1>
          <span class="sgd-spacer"></span>
          <app-user-menu [isMobile]="mobileQuery.matches"
            [style.marginRight.px]="mobileQuery.matches ? 0 : 265"></app-user-menu>
        </mat-toolbar>
        <div [style.marginTop.px]="mobileQuery.matches ? 54 : 60">
          <router-outlet />
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>